/**
 * MobileTabBar — bottom tab navigation for the native app (companion-first).
 *
 * Rendered by AppShell only when running inside the Capacitor native shell
 * (isNativeApp()), so the web experience is unchanged. Leads with the
 * mobile-native jobs: explore (Home / Archive), engage (Mysteries), review
 * (Inbox), account (Profile). The full nav is still reachable via the existing
 * hamburger drawer.
 *
 * Safe-area inset on the bottom keeps it clear of the iOS home indicator.
 */
import { NavLink } from 'react-router-dom'

const TABS = [
  {
    to: '/', end: true, label: 'Home',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <circle cx="12" cy="4" r="2"/><circle cx="5" cy="16" r="2"/><circle cx="19" cy="16" r="2"/>
        <line x1="12" y1="6" x2="7" y2="14"/><line x1="12" y1="6" x2="17" y2="14"/><line x1="12" y1="6" x2="12" y2="18"/>
      </svg>
    ),
  },
  {
    to: '/archive', label: 'Archive',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
        <line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/>
      </svg>
    ),
  },
  {
    to: '/mysteries', label: 'Mysteries',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <circle cx="12" cy="12" r="9"/>
        <path d="M9.5 9a2.5 2.5 0 1 1 5 0c0 1.5-1.5 2-2.5 3"/>
        <circle cx="12" cy="17" r="0.6" fill="currentColor"/>
      </svg>
    ),
  },
  {
    to: '/suggestions', label: 'Inbox', badgeKey: 'inbox',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
      </svg>
    ),
  },
  {
    to: '/profile', label: 'Profile',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
      </svg>
    ),
  },
]

export default function MobileTabBar({ inboxCount = 0 }) {
  return (
    <nav className="mobile-tabbar" role="navigation" aria-label="Primary">
      {TABS.map(tab => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          className={({ isActive }) => `mobile-tabbar__item ${isActive ? 'is-active' : ''}`}
        >
          <span className="mobile-tabbar__icon">
            {tab.icon}
            {tab.badgeKey === 'inbox' && inboxCount > 0 && (
              <span className="mobile-tabbar__badge">{inboxCount > 9 ? '9+' : inboxCount}</span>
            )}
          </span>
          <span className="mobile-tabbar__label">{tab.label}</span>
        </NavLink>
      ))}
    </nav>
  )
}
